/**
 * client.js
 * 
 * API for handling getting client raw data
 */

import axiosInstance from "./axios-instance";
import { promptDownload } from "../util/file";


/**
* GET request to return a list of programmes provided in Purapura DB
* @returns List of programmes
*/
const getProgrammeList = () => axiosInstance.get("/service/programmes").then(res => res)


/**
* GET request to return a list of teams/services provided in Purapura DB
* @returns List of services
*/
const getServicesList = () => axiosInstance.get("/service/service-types").then(res => res)

/**
* GET request to return a list of teams/services provided in Purapura DB
* @returns List of services
*/
const getDatabaseList = () => axiosInstance.get("/service/database-list").then(res => res)


/**
 * @desc Return a list of clients in Purapura DB
 * 
 * @returns List of active clients
 */
const getClientList = () => axiosInstance.get("/api/clients").then(res => res)


/**
 * @desc Return all clients registered in the app
 * 
 * @returns Clients that are registered in the app
 */
const getAppClients = () => axiosInstance.get('/app/clients').then(res => res)


/**
 * @desc Retrieves single app client account given an id
 * 
 * @param {Number} id of the client 
 * @returns 
 */
const getAppClientsById = (id) => axiosInstance.get(`/app/clients/data/${id}`).then(res => res)

/**
 * Returns the information of clients that have completed a response form.
 * @returns 
 */
const getClientsFormCompleted = (formTypeId = 1) => axiosInstance.get(`/app/clients/forms/completed`, {
    params: { formTypeId }
}).then(res => res)

/**
 * @desc Retrieves all client that are linked to a given userId
 * 
 * @param {*} userId staff id to retrieve clients for
 * @returns 
 */
const getAppClientsByStaffId = (userId) => axiosInstance.get(`/app/clients/staff/${userId}`).then(res => res)


/**
 * Returns an object of Purapura insights
 */
const getInsights = async () => await axiosInstance.get(`/app/clients/insights`).then(res => res)


/**
 * GET req to return all clients on waitlist
 * @returns Clients that are waitlist Purapura
 */
const getWaitlistData = async (query) => axiosInstance.get(`/app/clients/waitlist${query}`).then(res => res)


/**
 * GET req to return all types of ethnicities of Purapura clients
 * @returns ethnicities that are stored in Purapura
 */
const getEthnicityList = () => axiosInstance.get('/app/clients/ethnicity').then(res => res)

/**
 * GET req to return all types of iwi of Purapura clients
 * @returns iwi that are stored in Purapura
 */
const getEthnicityData = () => axiosInstance.get('/app/clients/ethnicity/table').then(res => res)

/**
 * GET req to return all types of iwi of Purapura clients
 * @returns iwi that are stored in Purapura
 */
const getIwiData = () => axiosInstance.get('/app/clients/iwi').then(res => res)


/**
 * GET req to return the net clients for the Purapura organization year to date
 * @returns object containing client entry and exit numbers
 */
const getNetClientsYTD = () => axiosInstance.get('/app/clients/net-clients').then(res => res)


/**
 * GET return active length of service for exited clients
 */
const getClientLengthOfService = () => axiosInstance.get('/app/clients/client-duration').then(res => res)


/**
  * @desc Gets a CSV file for download
  * @param {Object} filters filters to apply to the data that's pulled
  * @returns Not sure yet
 */
const getClientDemographicCSVExport = ()=> axiosInstance({
        url: `/clients/clientDemographic/CSVExport`,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        promptDownload(response.data, "Client Demographic.csv");
    })

/**
  * @desc Gets a CSV file for download
  * @param {Object} filters filters to apply to the data that's pulled
  * @returns Not sure yet
 */
const getClientActivityCSVExport = ()=> axiosInstance({
        url: `/clients/clientActivity/CSVExport`,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        promptDownload(response.data, "Client Activity.csv");
    })

/**
  * @desc Gets a CSV file for download
  * @param {Object} filters filters to apply to the data that's pulled
  * @returns Not sure yet
 */
const getClientWaitlistCSVExport = ()=> axiosInstance({
        url: `/clients/clientWaitlist/CSVExport`,
        method: 'GET',
        responseType: 'blob'
    }).then((response) => {
        promptDownload(response.data, "Client Waitlist.csv");
    })


const getClientTableData = (tableType, query) => axiosInstance.get(`/app/clients/tables/${tableType}/filters${query}`).then(res => res)


const getInteractionDataByClientId = (clientId) => axiosInstance.get(`/app/clients/interactions/all/${clientId}`).then(res => res)


const getHoursSpentByStaffId = (userId, query) => axiosInstance.get(`/app/staff/${userId}/hours${query}`).then(res => res)


const getPersonProfile = (personId) => axiosInstance.get(`/app/clients/profile/${personId}`).then(res => res)


export default {
    getProgrammeList,
    getServicesList,
    getDatabaseList,
    getClientList,
    getAppClients,
    getAppClientsById,
    getAppClientsByStaffId,
    getClientsFormCompleted,
    getInsights,
    getWaitlistData,
    getEthnicityList,
    getEthnicityData,
    getIwiData,
    getNetClientsYTD,
    getClientLengthOfService,
    getClientDemographicCSVExport,
    getClientActivityCSVExport,
    getClientWaitlistCSVExport,
    getClientTableData,
    getInteractionDataByClientId,
    getHoursSpentByStaffId,
    getPersonProfile
};
